import { render, staticRenderFns } from "./PAK.vue?vue&type=template&id=efe2118e&scoped=true&"
import script from "./PAK.vue?vue&type=script&lang=js&"
export * from "./PAK.vue?vue&type=script&lang=js&"
import style0 from "./PAK.vue?vue&type=style&index=0&id=efe2118e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe2118e",
  null
  
)

export default component.exports